import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { logPageView } from './lib/traffic-logger';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import BlogPostPage from './pages/BlogPostPage';
import TagPage from './pages/TagPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  const location = useLocation();

  // Log page views for traffic analytics
  useEffect(() => {
    logPageView({
      app: 'blog',
      path: location.pathname,
    });
  }, [location.pathname]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/post/:slug" element={<BlogPostPage />} />
        <Route path="/tag/:tag" element={<TagPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
